export const styles = theme => ({
    button: {
        margin: '8px',
    }, root: {
        display: "flex",
        flexWrap: "wrap"
    }, margin: {
        margin: '8px'
    },
    formControl: {
        minWidth: '194px'
    },
    marginLeft :{
        marginLeft: '8px'
    },withoutLabel: {
        marginTop: '8px' * 3
    }, textField: {
        flexBasis: 200
    }, topBarButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
    }, toggleMapButton: {
        color: '#ffffff',
        borderColor: '#104b72',
        borderWidth: 'thin',
        backgroundColor: '#4589b6',
        '&:hover': {
          backgroundColor: '#176ca4',
        },
        width: '817px'
    }, plainWhiteButton: {
        color: '#000',
        borderWidth: 'thin',
        backgroundColor: '#ffffff',
        width: '200px'
    }, clearPolygonButton: {
        color: '#000',
        borderWidth: 'thin',
        '&:hover': {
          backgroundColor: '#EE5353',
          // borderColor: '#B2B2B2',
        },
        // backgroundColor: '#EE5353',
    }, mapContainer: {
        backgroundColor: '#ebf0f4',
        borderStyle: 'solid',
        borderColor:'#4589b6',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }, metOptionsContainer: {
        width: '815px',
    }, toggleAdvancedOptionsButton: {
        // color: '#212121',
        // borderColor: '#878787',
        // borderWidth: 'thin',
        backgroundColor: 'white',
        '&:hover': {
          backgroundColor: '#EDEDED',
          borderColor: '#B2B2B2',
        },
        width: '817px'
    }
    , advancedOptionsContainer: {
        // backgroundColor: '#EDEDED',
        borderBottomStyle: 'solid',
        borderLeftStyle: 'solid',
        borderRightStyle: 'solid',
        borderColor:'#B2B2B2',
        borderWidth: 'thin',
        width: '815px',
        marginTop: '-10px'
    }
});
